import { render, staticRenderFns } from "./FloatingModal.vue?vue&type=template&id=6c12e5b6&scoped=true"
import script from "./FloatingModal.vue?vue&type=script&lang=js"
export * from "./FloatingModal.vue?vue&type=script&lang=js"
import style0 from "./FloatingModal.vue?vue&type=style&index=0&id=6c12e5b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12e5b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalCloseButton: require('/vercel/path0/components/ModalCloseButton.vue').default})
